








// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import apiMedia from '@/api/media'
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import * as rules from '@/utils/validationRules'
import { directPayloadQuery } from '@/utils/api'
import { toStringDictionary } from '@/utils/groupBy'
import { AloMedia, getDefaultAloMedia } from '@/models/alo/AloMedia'


@Component({
  name: 'EditImage',    
  components:{EditDrawer},  
})
export default class EditImage extends Vue {
  
  private original:AloMedia = getDefaultAloMedia()
  private modified:AloMedia = getDefaultAloMedia()
  private showDrawer = false
  private saving = false
  private status = ""  
  
  
  mounted(){          
  }


  edit(item:AloMedia) {        
    this.status = ""
    this.showDrawer = true
    this.original = {...getDefaultAloMedia(),...item}
    this.modified = cloneDeep(this.original)    
      
  } 
    

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  saveData() {    
    if ((this.$refs.editConfigForm as HTMLFormElement).validate()) {
      this.$emit("update",this.modified) 
      
      this.showDrawer = false
    }
  }
}
